import { TSDIGITAL_API_URL } from "../../config";
import axios from "axios";
import { createHttpHeader } from "./http-header";
import { authConstants } from "../actions/auth";

export function refreshToken(auth, dispatch) {
  return new Promise(function(resolve, reject) {
    let request = {
      method: "POST",
      url: `${TSDIGITAL_API_URL}/login/agyo`,
      headers: createHttpHeader(auth.loginAuth.correlationId),
      data: {
        id: auth.loginAuth.id,
        digest: auth.loginAuth.refreshToken
      }
    };
    axios(request)
      .then((response) => {
        dispatch({
          type: authConstants.LOGIN_SUCCESS,
          payload: {
            loginAuth: {
              securityToken: response.data.token,
              id: auth.loginAuth.id,
              appName: auth.loginAuth.appName,
              refreshToken: auth.loginAuth.refreshToken,
              tsId: auth.loginAuth.tsId,
              tsLogin: auth.loginAuth.tsLogin
            }
          }
        });
        resolve(response.data.token);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
